module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-4-b9c05d92.jpg";